module.exports = __webpack_public_path__ + "img/niño51.1aa9d06a.jpg";